"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Button: ()=>Button_Button
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Button_variants_cjs_namespaceObject = require("./Button.variants.cjs");
const Button_Button = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ children, className, disabled, iconLeft, iconRight, loading, buttonType = 'button', ...props }, ref) {
    const { buttonSlot, textSlot, iconSlot } = (0, external_Button_variants_cjs_namespaceObject.buttonVariants)({
        ...props,
        disabled: disabled || loading
    });
    const iconSlotClasses = iconSlot();
    const iconSize = 'sm' === props.size || 'md' === props.size ? '20' : '24';
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("button", {
        ref: ref,
        type: buttonType,
        className: (0, index_cjs_namespaceObject.cn)(buttonSlot(), className),
        ...(0, index_cjs_namespaceObject.cleanProps)(props, [
            'type',
            'shadow',
            'fullWidth'
        ]),
        disabled: disabled || loading,
        "aria-busy": loading,
        children: [
            loading && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                className: (0, index_cjs_namespaceObject.cn)('animate-spin', iconSlotClasses),
                iconName: "refresh",
                size: iconSize
            }),
            iconLeft && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                iconName: iconLeft,
                className: iconSlotClasses,
                size: iconSize
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                className: textSlot(),
                children: children
            }),
            iconRight && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                iconName: iconRight,
                className: iconSlotClasses,
                size: iconSize
            })
        ]
    });
});
exports.Button = __webpack_exports__.Button;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Button"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
